<template>
  <div class="maskBox">
    <img src="../../assets/images/cashWheel/close2.png" alt="" class="close" @click="close(true)">
    <div class="taskBox">
      <div class="mask" @click="close"></div>
      <div class="itemBox1" :style="{backgroundImage:'url('+require('../../assets/images/cashWheel/taskBoxBg.webp')+')'}">
        <div class="title">{{$t('lang.cashWheel.MyWinningAmount')}}</div>
        <div class="deepBox">
          <div class="deepBoxs">
            <div class="deep" :style="{'width':deepWith + '%'}"></div>
            <div class="deepBg"></div>
          </div>
          <div class="deepNum">₹{{balance}}/₹{{ getTargetNum(balance) }}</div>
        </div>
        <div :class="lang === 'EN'?'expectedTip':'expectedTipIN'">{{$t('lang.cashWheel.ExpectedTo')}}</div>
        <div class="getRewardsBox">
          <div class="rewardsTitle">{{$t('lang.cashWheel.GetRewards')}}
            <img class="ruleBtnIcon" @click="ruleShow = true" src="../../assets/images/cashWheel/ruleBtnIcon.png" alt="">
          </div>
          <div class="taskBoxB">
            <div class="taskItem">
              <img src="../../assets/images/cashWheel/taskIcon.png" class="taskIcon" alt="">
              <div class="taskTitle">{{$t('lang.cashWheel.InviteTip1')}}</div>
              <div v-if="DepositAwait !== 0" class="getBtn" @click="get('deposit')">{{$t('lang.cashWheel.get')}}<span style="margin-left: 1vw">x{{DepositAwait}}</span></div>
              <div v-else class="shareBtn" @click.stop="close()">{{$t('lang.cashWheel.share')}}</div>
            </div>
            <div class="taskItem">
              <img src="../../assets/images/cashWheel/taskIcon2.png" class="taskIcon" alt="">
              <div class="taskTitle">{{$t('lang.cashWheel.InviteTip2')}}</div>
              <div v-if="BetAwait !==0" class="getBtn" @click.stop="get('bet')">{{$t('lang.cashWheel.get')}} <span style="margin-left: 1vw">x{{BetAwait}}</span> </div>
              <div v-else class="shareBtn" @click.stop="close()">{{$t('lang.cashWheel.share')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="itemBox2">
        <div class="ListWinners">
          <div class="listViewMask"></div>
          <div class="listOfWinners">{{$t('lang.cashWheel.listOfWinners')}}</div>
          <div class="listView" ref="listViewBox">
            <el-carousel height="30vw" @change="lookCarousel" direction="vertical" :autoplay="true" indicator-position="none" :interval="delay" :loop="true">
              <el-carousel-item v-for="(chunk, chunkIndex) in chunkedUserDataList" :key="chunkIndex">
                <div v-for="(item, index) in chunk" :key="index" class="viewItem">
                  <div class="userInfoBox">
                    <img class="userImg" :src="item.userImg" alt="">
                    <div class="userName">{{ item.userName }}</div>
                  </div>
                  <div class="TimeBox">{{ lang === 'EN' ? item.getTime : item.getTimeIN }}</div>
                  <div class="withDraw">{{ $t('lang.cashWheel.withdraw') }} <span>{{ item.amount }}</span></div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="mask2" @click="close"></div>
    </div>
    <div class="ruleBoxMarsk" v-if="ruleShow">
      <div class="ruleBox">
        <img @click="ruleShow = false" src="../../assets/images/cashWheel/close.png" alt="" class="closeRuleBtn">
        <div class="title">{{$t('lang.cashWheel.ruleTitle')}}</div>
        <div class="ruleContentBox" v-html="RuleText"></div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import {userDataList} from './userData'
export default {
  name: 'modal-task',
  props: {
    balance: {
      type: Number,
      default: 0
    }
  },
  computed: {
    chunkedUserDataList () {
      return this.chunkArray(this.userDataList, 3)
    }
  },
  data () {
    return {
      RuleText: '',
      ruleShow: false,
      delay: 2000,
      timers: null,
      lang: localStorage.getItem('locale'),
      scrollDuration: 200,
      intervalId: null,
      userDataList: userDataList,
      deepWith: 0,
      BetAwait: 0,
      DepositAwait: 0
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
  },
  mounted () {
    this.getRule()
    this.shuffleArray(this.userDataList)
    this.setRandomTimer()
    this.selectGet()
    this.setDeepValue()
  },
  methods: {
    getTargetNum (val) {
      return ((Math.floor((val - 1) / 500) + 1) * 500) === 0 ? 500 : ((Math.floor((val - 1) / 500) + 1) * 500)
    },
    lookCarousel (val) {
      if (val === this.userDataList.length / 3 - 1) {
        this.shuffleArray(this.userDataList)
      }
    },
    shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]] // 交换元素
      }
    },
    setRandomTimer () {
      // 生成2-6秒的随机时间
      const delay = Math.floor(Math.random() * (6000 - 2000 + 1)) + 2000

      // 设置定时器
      this.timers = setTimeout(() => {
        // 如果需要重复定时器，可以重新调用setRandomTimer()
        this.setRandomTimer()
        this.delay = delay
      }, this.delay * 2)
    },
    chunkArray (array, size) {
      const chunkedArray = []
      for (let i = 0; i < array.length; i += size) {
        chunkedArray.push(array.slice(i, i + size))
      }
      return chunkedArray
    },
    getRule () {
      let data = {
        Type: 'VirTaskRule',
        Local: localStorage.getItem('locale'),
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null
      }
      request('post', '/innovation/virality/get/rule', data, false).then(res => {
        console.log(res)
        this.RuleText = res.RuleText.replace(/\n/g, '<br>')
      })
    },
    get (type) {
      let data = {
        Type: type,
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/collect/draw/count', data, false).then(res => {
        console.log(res)
        if (res.Code === 1) {
          this.$emit('getSuccess', res.UpdateNumber)
          this.selectGet()
        }
      })
    },
    close (noShare) {
      this.$emit('closeModalTask', noShare)
    },
    setDeepValue () {
      if (this.balance !== 0) {
        setTimeout(() => {
          this.deepWith = (this.balance / this.getTargetNum(this.balance)) * 100
        })
      } else {
        this.deepWith = 0
      }
    },
    selectGet () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null

      }
      if (data.UserId) {
        request('post', 'innovation/virality/get/await/collect', data, false).then(res => {
          if (res.Code === 1) {
            this.BetAwait = res.BetAwait
            this.DepositAwait = res.DepositAwait
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes expandInOut {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.ruleBoxMarsk{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .ruleBox{
    animation: expandInOut  0.2s ease-out forwards;
    height: 111.38vw;
    width: 88.34vw;
    background-color: #181818;
    border-radius: 3vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    .closeRuleBtn{
      height: 4.055vw;
      width: 4.055vw;
      position: absolute;
      left: 81vw;
      top: -7vw;
    }
    .title{
      margin-top: 6vw;
      background-image: linear-gradient(to right, #F5EFBA, #F8EDC6);
      color: transparent;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: bold;
      font-size: 5.277vw;
    }
    .ruleContentBox{
      margin-top: 5vw;
      height: 88.11vw;
      width: 77.58vw;
      border-radius: 3vw;
      background-color: #FDFDF5;
      padding: 1.5vw;
      color: #000000;
      font-size: 3.88vw;
      font-weight: 700;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close{
  height: 4.75vw;
  width: 4.55vw;
  position: absolute;
  top: 3vw;
  left: 80vw;
  z-index:999;
}
.taskBox{
  position: fixed;
  top: 0;
  left: 0;
  height: 220.77vw;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform-origin: center;
  animation-name: expandInOut;
  animation-duration: 0.2s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
  .mask{
    height: 33vw;
    width: 100%;
    background: transparent;
    position: absolute;
  }
  .itemBox1{
    width: 100%;
    height: 125.88vw;
    //border: 1px solid red;
    background-size: 114%;
    background-position-x: 1vw;
    background-position-y: 0vw;
    background-repeat: no-repeat;
    point-event:none;
    .title{
      color: #000;
      font-size: 4.58vw;
      font-weight: 900;
      font-style: italic;
      position: absolute;
      top: 27vw;
      left: 6vw;
      z-index: 10;
    }
    .deepBox{
      background-color: #FFFFE7;
      width: 87.17vw;
      height: 12.77vw;
      border-radius: 3vw;
      position: absolute;
      top: 44vw;
      left: 6vw;
      display: flex;
      align-items: center;
      border-radius: 2.22vw;
      overflow: hidden;
      .deepBoxs{
        width: 58.88vw;
        height: 2.22vw;
        position: relative;
        border-radius: 2.22vw;
        z-index: 10;
        margin-left: 4vw;
        .deep{
          height: 100%;
          //width: 50%;
          position: absolute;
          background-color: red;
          border-radius: 2.22vw;
          background: -webkit-linear-gradient(left, #FF9E0C 0%, #83E000 47%, #00AA25 100%);
          transition: all 3s ease;
        }
        .deepBg{
          height: 100%;
          width: 100%;
          background-color: #000;
          border-radius: 2.22vw;
        }
      }
      .deepNum{
        font-size: 3.61vw;
        font-weight: 700;
        color: #000;
        margin-left: 1vw;
      }
    }
    .expectedTip{
      color: #9C0003;
      font-size: 3.194vw;
      position: absolute;
      top: 58vw;
      left: 13vw;
    }
    .expectedTipIN{
      color: #9C0003;
      font-size: 3.194vw;
      position: absolute;
      top: 58vw;
      left: 10vw;
    }
    .getRewardsBox{
      height: 53.33vw;
      width: 87.17vw;
      background-color: rgb(61,62,43);
      border-radius: 3.05vw;
      position: absolute;
      top: 66vw;
      left: 6.3vw;
      .rewardsTitle{
        font-size: 5.27vw;
        color: #fff;
        font-weight: 700;
        text-align: center;
        margin-top: 3vw;
        .ruleBtnIcon{
          height: 6.388vw;
          width: 5.858vw;
          position: relative;
          top: 1vw;
          left: 18vw;
        }
      }
      .taskBoxB{
        //border: 1px solid red;
        height: 42vw;
        margin-top: 2vw;
        display: flex;
        flex-direction: column;
        gap: 6vw;
        .taskItem{
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;
          .taskIcon{
            height: 14.44vw;
            width: 14.44vw;
          }
          .taskTitle{
            font-size: 3.61vw;
            color: #fff;
            width: 47.77vw;
          }
          .getBtn{
            width: 15.88vw;
            height: 7.5vw;
            background-color: #FFD453;
            border-radius: 4.16vw;
            color: #000000;
            text-align: center;
            line-height: 7.5vw;
            font-weight: 700;
            font-size: 3.61vw;
          }
          .shareBtn{
            width: 15.88vw;
            height: 7.5vw;
            background-color: #0084FF;
            border-radius: 4.16vw;
            color: #FFFFFF;
            text-align: center;
            line-height: 7.5vw;
            font-weight: 700;
            font-size: 3.61vw;
          }
        }
      }
    }
  }
  .mask2{
    height: 38vw;
    width: 100%;
    background: transparent;
  }
  .itemBox2{
    point-event:none;
    width: 91.7vw;
    height: 41.5vw;
    background-size: 100% 100%;
    position: relative;
    left: -0.5vw;
    display: flex;
    flex-direction: column;
    background: linear-gradient(to right, #FFCEDF 10%,#FFF2C1 50%, #FFF2C1 60% #FFCEDF 75%,#FFCEDF 100%);
    border-radius: 3vw;
    overflow: hidden;
    .viewItem:nth-child(odd) {
      height: 10.3vw;
      background: linear-gradient(to right, rgb(189,178,109) 0%,rgb(210,191,157) 50%,  rgb(175,123,87) 100%);
    }
    .viewItem:nth-child(even) {
      height: 10.3vw;
      background: linear-gradient(to right, rgb(255,247,217) 0%, rgb(255,247,217) 100%);
    }
    .ListWinners{
      overflow: hidden;
      position: relative;
    }
    .listViewMask{
      height: 100%;
      width: 100%;
      position: absolute;
      background-color: transparent;
      z-index: 10;
    }
    .listOfWinners{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 12vw;
      //border: 1px solid red;
      font-size: 4.722vw;
      color: #000;
      font-weight: 700;
      letter-spacing: 0.1vw;
      position: relative;
      top: 2vw;
    }
    .listView::-webkit-scrollbar{
      opacity: 0;
      width: 0;
    }
    .listView{
      //border: 1px solid red;
      height: 31.4vw;
      width: 100%;
      //background-color: green;
     overflow: hidden;
      border-radius: 0vw 0vw 3vw 3vw;
      .viewItem:nth-child(odd) {
        color: #fff;
        span{
          color: #FFE688;
        }
        //background: -webkit-linear-gradient(left, rgb(116,104,19) 0%, rgb(88,72,22) 50%, rgb(64,44,25) 100%);
      }
      .viewItem:nth-child(even) {
        //background-color: #f2f2f2;
        color: #442626;
        span{
          color: #CA1B00;
        }
      }
      .viewItem{
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 10vw;
        width: 100%;
        //border: 1px solid red;
        font-size: 2.777vw;
        color: #fff;
        //border-bottom: 1px solid #fff;
        .userInfoBox{
          flex: 1;
          display: flex;
          align-items: center;
          gap: 2vw;
          .userImg{
            height: 6.55vw;
            width: 6.55vw;
            margin-left: 2vw;
            border-radius: 5vw;
          }
          .userName{
            font-weight: 700;
          }
        }
        .TimeBox{
          flex: 1;
        }
        .withDraw{
          flex: 1;
          font-weight: 700;
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-task.vue